import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  user: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    flexDirection: 'row',
    margin: 0,
    padding: 0
  },
  content: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginLeft: theme.spacing.sm
  },
  nameWrapper: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
}));
